let runtimeConfig = null;

export async function loadRuntimeConfig() {
  // Base URL can initially rely on build-time for just this call
  const baseUrl = process.env.REACT_APP_BASE_URL || "/";
  const apiBase = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
  const response = await fetch(`${apiBase}config/frontend-config`, { credentials: 'include' });
  if (!response.ok) {
    throw new Error(`Failed to load config: ${response.status}`);
  }
  runtimeConfig = await response.json();
  return runtimeConfig;
}

export function getConfig() {
  if (!runtimeConfig) {
    throw new Error("Runtime config not loaded. Call loadRuntimeConfig() first.");
  }
  return runtimeConfig;
}


